module.exports = __webpack_public_path__ + "b08aa08ca3a4497f6bff25ad4829fe4c.jpg";